import { Component } from "react";
import { Button } from "@/components/ui/button";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (typeof window !== "undefined" && window.posthog) {
      try {
        window.posthog.captureException(error, { info });
      } catch (_) {
        /* noop */
      }
    }
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  handleReload = () => {
    this.setState({ hasError: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-boundary"
          className="min-h-screen bg-[#050505] text-white flex items-center justify-center px-6"
        >
          <div className="max-w-md text-center">
            <div className="text-xs uppercase tracking-[0.22em] text-[#FF5A00] mb-4">
              Something broke
            </div>
            <h1 className="font-heading text-4xl font-medium tracking-tight mb-3">
              We hit a bump.
            </h1>
            <p className="text-zinc-400 mb-8">
              An unexpected error occurred. We&rsquo;ve been notified — please
              reload the page.
            </p>
            <Button
              onClick={this.handleReload}
              className="bg-[#FF5A00] hover:bg-[#FF7A33] text-white rounded-full px-7 h-12"
            >
              Reload
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
